<template>
  <div :id="`${source}_action_wrapper`">
    <a-tooltip :position="position" color="var(--tooltip-bg)">
      <template #title>
        <span class="text-[13px] font-normal primary_color">{{
          title || "Title"
        }}</span>
      </template>

      <div
        class="flex action_wrapper"
        :class="disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'"
        :style="{ padding: `${padding}px`, borderRadius: `${borderRadius}px` }"
        @click="handleClick"
      >
        <slot />
      </div>
    </a-tooltip>
  </div>
</template>

<script setup>
const props = defineProps({
  source: { type: String, required: true },
  position: { type: String, default: "top" },
  tooltip: { type: String, default: "" },
  title: { type: String, required: true },
  padding: { type: Number, default: 6 },
  borderRadius: { type: Number, default: 8 },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["click"]);

const handleClick = (event) => {
  try {
    if (props.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    emit("click", event);
  } catch (error) {
    console.error("An error occurred while handling click: ", error);
  }
};
</script>

<style scoped>
.action_wrapper:not(.cursor-not-allowed):hover,
.action_wrapper.selected {
  background-color: var(--white-opacity-4);
  transition: background-color 0.4s ease-in-out;
}
</style>
